import { useMutation } from '@apollo/client';
import { DeleteOversightResultsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteOversightResultsTRPC } from './useDeleteOversightResultsTRPC';

export const useDeleteOversightResults = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteGraphQL, graphqlState] = useMutation(
    DeleteOversightResultsDocument,
    {
      update: (cache) => {
        evictField(cache, 'obligation_oversight_result');
        evictField(cache, 'document_oversight_result');
        evictField(cache, 'control_test_oversight_result');
        evictField(cache, 'risk_controlled_oversight_result');
        evictField(cache, 'risk_uncontrolled_oversight_result');
        evictField(cache, 'oversight_assessment');
        evictField(cache, 'obligation_oversight_result_aggregate');
        evictField(cache, 'document_oversight_result_aggregate');
        evictField(cache, 'control_test_oversight_result_aggregate');
        evictField(cache, 'risk_controlled_oversight_result_aggregate');
        evictField(cache, 'risk_uncontrolled_oversight_result_aggregate');
      },
    }
  );

  const trpcMutation = useDeleteOversightResultsTRPC();

  const deleteOversightResults = async (ids: string[]): Promise<void> => {
    if (trpcEnabled) {
      await trpcMutation.deleteOversightResults(ids);

      return;
    }

    await deleteGraphQL({ variables: { Ids: ids } });
  };

  if (trpcEnabled) {
    return {
      deleteOversightResults,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteOversightResults,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
